import { useState } from "react";
import { AppContext } from "./contexts/AppContext";
import Header from "./ui-components/Header";
import Footer from "./ui-components/Footer";
import FileUploadComponent from "./ui-components/FileUploadComponent";
import ViewerWindow from "./3d-components/R3fViewer";
import { Canvas } from "@react-three/fiber";
import Toolbar from "./ui-components/Toolbar.js";
import SettingsComponent from "./ui-components/SettingsComponent.js";
import InfoComponent from "./ui-components/InfoComponent";
import NotificationComponent from "./ui-components/NotificationComponent";
import VerticalMenu from "./ui-components/VerticalMenu";
import PanelComponent from "./ui-components/TableComponent";
function App() {
  const [file, setFile] = useState();
  const [notification, setNotification] = useState();
  const [loader, setLoader] = useState(false);
  const [grid, setGrid] = useState(true);
  const [info, setInfo] = useState();
  const [table, setTable] = useState();

  let loaderDiv = (
    <>
      {Array(3)
        .fill()
        .map((el, index) => (
          <div key={index} className="rhombus-loader"></div>
        ))}
    </>
  );
  return (
    <AppContext.Provider
      value={{
        file,
        setFile,
        notification,
        setNotification,
        loader,
        setLoader,
        grid,
        setGrid,
        info,
        setInfo,
        table,
        setTable,
      }}
    >
      <div className="wrapper">
        <Header />

        <div id="scene-container">
          {loader === true && <div id="loader-container">{loaderDiv} </div>}

          {file === undefined ? (
            <>
              <FileUploadComponent></FileUploadComponent>
            </>
          ) : (
            // show file
            <>
              <VerticalMenu></VerticalMenu>
              <div id="canvas-3d">
                <Canvas gl={{ preserveDrawingBuffer: true }}>
                  <ViewerWindow />
                </Canvas>
              </div>

              <Toolbar />
            </>
          )}
          <SettingsComponent></SettingsComponent>
          <NotificationComponent></NotificationComponent>
          <InfoComponent></InfoComponent>
          <PanelComponent></PanelComponent>
        </div>
        <Footer />
      </div>
    </AppContext.Provider>
  );
}

export default App;
